export enum ZtIcon {
    ADD_DOCUMENT = 'add-document',
    ARROW_RIGHT = 'arrow-right',
    ARROWS_UP_DOWN = 'arrows-up-down',
    COPY = 'copy',
    DELETE = 'delete',
    DOWNLOAD = 'download',
    FILTER_ASC = 'filter-asc',
    FILTER_DESC = 'filter-desc',
    INFO = 'info',
    PAUSE = 'pause',
    PLAY = 'play',
    POP_OUT = 'pop-out',
    SAVE = 'save',
    STOP = 'stop',
}
